import { Component } from '@angular/core';

@Component({
    selector: 'vg-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent {}
